import React from "react";
import { Router, Route, Redirect, Switch } from "react-router-dom";
import { connect } from "react-redux";
import { ROUTES } from "../new/api-constant";
import { history } from "../_helpers";
import { alertActions } from "../_actions";
import { PrivateRoute } from "../_components";
import Admin from "../_pages/Admin/index.jsx";
import Sellers from "../_pages/Admin/Sellers";
import Organisation from "../_pages/Admin/Organisation";
import AllotmentSummary from "../_pages/Admin/AllotmentSummary";
import Details from "../_pages/Admin/Sellers/Details";
import OrgDetails from "../_pages/Admin/Organisation/Details";
import primaryOrgDetails from "../_pages/Admin/Organisation/PrimaryOrgAdmin";
import { LoginPage } from "../_pages/Login/LoginPage";
import RelationGroups from "../_pages/Admin/RelationGroups";
import RelationGroupDetails from "../_pages/Admin/RelationGroups/Details";
import CustomTag from "../_pages/Admin/Organisation/DetailLinks/CustomTags";
import BatchDetails from "../_pages/Admin/Organisation/DetailLinks/BatchDetails";
import ManageParticipents from "../_pages/Admin/Organisation/DetailLinks/ManageParticipents";
import ManageMatrix from "../_pages/Admin/Organisation/DetailLinks/manageMatrix";
import GroupReport from "../_pages/Admin/Organisation/DetailLinks/groupReport.jsx";
import RoleFitmentReport from "../_pages/Admin/Organisation/DetailLinks/RoleFitmentReport/RoleFitmentReport.jsx";
import Worksheet from "../_pages/DashBoard/worksheet/worksheet";
import WorksheetDetails from "../_pages/DashBoard/worksheet/worksheetdetails/details";
import WorksheetShare from "../_pages/DashBoard/worksheet/worksheetdetails/worksheetShared/shared";
import UploadAssessment from "../_pages/Admin/Organisation/DetailLinks/UploadAssessment";
import UploadAssessmentResponse from "../_pages/Admin/Organisation/DetailLinks/uploadAssessmentResponse";
import UploadRespondent from "../_pages/Admin/Organisation/DetailLinks/UploadRespondent";
import DevelopmentPlan from "../_pages/Admin/DevelopmentPlan";
import AssessmentSummary from "../_pages/Admin/AssessmentSummary";
import Assessment from "../_pages/Admin/AssessmentSummary/Assessment";
import UserDetails from "../_pages/Dashboard/user-details";
import DashBoardReport from "../_pages/DashBoard/index";
import viewReport from "../_pages/DashBoard/viewReport/viewReport";
import continueReport from "../_pages/DashBoard/continueReport/continueReport";
import LOIReport from "../_pages/DashBoard/LOI/loiAssessment";
import ReportDownlaod from "../_pages/DashBoard/viewReport/ReportDownlaod";
import AssessmentCompleted from "../_pages/AssessmentCompleted/index.jsx";
import Assessments from "../_pages/Assessments";
import UploadDemographicData from "../_pages/Admin/UploadDemographicData";
import { ToastContainer } from "react-toastify";
import Authorization from "../_components/common/Authorization";
import { SetPassword } from "../_pages/SetPassword";
import { RedirectingLoginPage } from "../_pages/RedirectingLogin/RedirectLoginPage.jsx";
import { ChangePassword } from "../_pages/Changepassword";
import { ChangeAdminPassword } from "../_pages/ChangeAdminPassword";
import { ForgotPassword } from "../_pages/ForgotPassword";
import DemographicMasters from "../_pages/Admin/DemographicMasters";
import CustomEmails from "../_pages/Admin/CustomEmails"
import CsvDownload from "../_pages/Admin/CsvDownload";
import ReportContent from "../_pages/Admin/ReportContent";
import ReportDetails from "../_pages/Admin/ReportContent/ReportDetails";
import NewDashboard from "../new/Dashboard";
import MyReports from "../new/Components/Reports";
import Downloadreports from "../new/Components/Reports/Download-Reports";
import CompareAssessment from "../new/Components/Reports/CompareAssessment/index.jsx";
import CreateProfile from "../new/Components/View-Or-Edit-profile/CreateProfile/index";
import EditProfile from "../new/Components/View-Or-Edit-profile/EditProfile/index";
import Renderuserwelcome from "../new/Components/Welcome/index";
import Renderselfassessment from "../new/Components/Self-assessment/index";
import Renderinvitationsflow from "../new/Components/Invitations";
import Rendersubmitassessment from "../new/Components/SubmitAssessment";
import Renderquestionnaire from "../new/Components/Self-assessment/begin-questionnaire";
import Rendercompletedassessmentscreen from "../new/Components/CompletedAssessment/index";
import MyWorksheet from "../new/Dashboard/Admin/Goal-Setting-Worksheets/index";
import Worksheets from "../new/Dashboard/Admin/WorksheetDetails/index";
import ManageWorkSheet from "../new/Dashboard/Admin/Manage-WorkSheet/index";
import Emptydashboard from "../new/Dashboard/Dashboard-empty";
import { AssessmentListComponent } from "../new/Components/Reports/Assessment/index.jsx";
import { AssessmentReports } from "../new/Components/Reports/Assessment-Reports/index.jsx";


import page404 from "../_pages/404page";

class App extends React.Component {
  constructor(props) {
    super(props);

    const { dispatch } = this.props;
    history.listen((location, action) => {

      dispatch(alertActions.clear());
    });
  }

  render() {
    const userType = localStorage.getItem("usertype");
  

   

    const auth = Authorization(localStorage.getItem("permissions"));


    return (
      <div style={{ height: "100%" }}>
        <Router history={history}>
          <div style={{ height: "100%" }}>
            <Switch>
              <PrivateRoute
                exact
                path="/admin/app/dashboard"
                component={Admin}
              />
              <PrivateRoute
                exact
                path="/admin/app/sellers"
                component={auth(Sellers, "seller_create_list")}
              />

              <PrivateRoute
                exact
                path="/admin/app/sellers/:id"
                component={auth(Details, "seller_view")}
              />
              <PrivateRoute
                exact
                path="/admin/app/organisation"
                component={auth(Organisation, "organisation_list")}
              />
              <PrivateRoute
                exact
                path="/admin/app/organisation/:id/"
                component={auth(OrgDetails, "organisation_view")}
              />
              <PrivateRoute
                exact
                path="/admin/app/organisation/:id/manageBatchPermissions"
                component={auth(primaryOrgDetails, "org_admin_list")}
              />
              <PrivateRoute
                exact
                path="/admin/app/organisation/:id/manageBatches"
                component={auth(CustomTag, "org_batch_list")}
              />
              <PrivateRoute
                exact
                path="/admin/app/organisation/:id/manageParticipants"
                component={auth(
                  ManageParticipents,
                  "organisation_list_participant"
                )}
              />
              <PrivateRoute
                exact
                path="/admin/app/organisation/:id/:customtag/:id"
                component={auth(BatchDetails, "org_batch_detail_view")}
              />
              <PrivateRoute
                exact
                path="/admin/app/organisation/:id/uploadAssessment"
                component={UploadAssessment}
              />
              <PrivateRoute
                exact
                path="/admin/app/organisation/:id/uploadAssessmentResponse"
                component={UploadAssessmentResponse}
              />
              <PrivateRoute
                exact
                path="/admin/app/organisation/:id/uploadRespondent"
                component={UploadRespondent}
              />
              <PrivateRoute
                exact
                path="/admin/app/organisation/:id/groupReport"
                component={GroupReport}
              />
              <PrivateRoute
                exact
                path="/admin/app/organisation/:id/manage-roles"
                component={RoleFitmentReport}
              />
              <PrivateRoute
                exact
                path="/admin/app/organisation/:id/manageMetrics"
                component={auth(
                  ManageMatrix,
                  "organisation_competency_matric_list"
                )}
              />
              <PrivateRoute
                exact
                path="/admin/app/relation-groups"
                component={auth(RelationGroups, "relation_group_list")}
              />
              <PrivateRoute
                exact
                path="/admin/app/relation-groups/:id"
                component={auth(RelationGroupDetails, "view_relation_group")}
              />
              <PrivateRoute
                exact
                path="/admin/app/development-plan"
                component={auth(
                  DevelopmentPlan,
                  "development_plan_list_create"
                )}
              />
              <PrivateRoute
                exact
                path="/admin/app/assessment-summary"
                component={auth(AssessmentSummary, "assessment_summary")}
              />
              <PrivateRoute
                exact
                path="/admin/app/assessment-summary/assessments/:id"
                component={auth(Assessment, "assessment_details")}
              />
              {/* Dashboard */}
              <PrivateRoute
                exact
                path="/app/dashBoard"
                component={
                  userType && userType.includes("super_admin")
                    ? DashBoardReport
                    : NewDashboard
                }
              />
              <PrivateRoute
                exact
                path={ROUTES.dashboard}
                component={NewDashboard}
              />
              <PrivateRoute exact path={ROUTES.reports} component={MyReports} />
              <PrivateRoute
                exact
                path={ROUTES.downloadreports}
                component={Downloadreports}
              />
              <PrivateRoute
                exact
                path={ROUTES.compareAssesment}
                component={CompareAssessment}
              />

              <PrivateRoute
                exact
                path={ROUTES.comparedAssessmentList}
                component={AssessmentListComponent}
              />
              <PrivateRoute
                exact
                path={ROUTES.comparedAssessmentReport}
                component={AssessmentReports}
              />

              <PrivateRoute
                exact
                path={ROUTES.createProfile}
                component={CreateProfile}
              />
              <PrivateRoute
                exact
                path={ROUTES.editProfile}
                component={EditProfile}
              />
              <PrivateRoute
                exact
                path={ROUTES.welcome}
                component={Renderuserwelcome}
              />
              <PrivateRoute
                exact
                path={ROUTES.welcomeInvitations}
                component={Renderuserwelcome}
              />
              <PrivateRoute
                exact
                path={ROUTES.selfAssessment}
                component={Renderselfassessment}
              />
              <PrivateRoute
                exact
                path={ROUTES.invitations}
                component={Renderinvitationsflow}
              />
              <PrivateRoute
                exact
                path={ROUTES.submitAssessment}
                component={Rendersubmitassessment}
              />
              <PrivateRoute
                exact
                path={ROUTES.beginQuestionnaire}
                component={Renderquestionnaire}
              />
              <PrivateRoute
                exact
                path={ROUTES.CompletedAssessmentScreen}
                component={Rendercompletedassessmentscreen}
              />
              <PrivateRoute
                exact
                path={ROUTES.MyWorksheet}
                component={MyWorksheet}
              />

              <PrivateRoute
                exact
                path={ROUTES.Emptydashboard}
                component={Emptydashboard}
              />
              <PrivateRoute
                exact
                path={ROUTES.Worksheets}
                component={Worksheets}
              />

              <PrivateRoute
                exact
                path={ROUTES.ManageWorkSheet}
                component={ManageWorkSheet}
              />

              <PrivateRoute
                exact
                path="/app/dashboard/viewReport/:id"
                component={viewReport}
              />
              <PrivateRoute
                exact
                path="/app/dashboard/:id/workSheet"
                component={Worksheet}
              />
              <PrivateRoute
                exact
                path="/app/dashboard/:id/workSheet/:id"
                component={WorksheetDetails}
              />
              <PrivateRoute
                exact
                path="/app/dashboard/:id/workSheet/:id/manageWorksheetShare"
                component={WorksheetShare}
              />
              <PrivateRoute
                exact
                path="/app/dashBoard/viewReport/:id/Download"
                component={ReportDownlaod}
              />
              <PrivateRoute
                exact
                path="/app/dashBoard/continueReport/:id"
                component={continueReport}
              />
              <PrivateRoute
                exact
                path="/app/dashBoard/continueReport/:id/assessments"
                component={Assessments}
              />
              <PrivateRoute
                exact
                path="/app/dashBoard/continueReport/:id/LOIReport"
                component={LOIReport}
              />
              <PrivateRoute
                exact
                path="/admin/app/allotment-summary"
                component={AllotmentSummary}
              />

              <PrivateRoute
                exact
                path="/admin/app/demographic-masters"
                component={DemographicMasters}
              />

              <PrivateRoute
                exact
                path="/new/app/user-details"
                component={UserDetails}
              />

              <PrivateRoute exact path="/assessments" component={Assessments} />

              <PrivateRoute
                exact
                path="/admin/upload-demographic-data"
                component={auth(UploadDemographicData, "demographic_list_data")}
              />

              <PrivateRoute
                exact
                path="/admin/app/custom-emails"
                component={CustomEmails}
              />
              <PrivateRoute
                exact
                path="/admin/app/csv-downloads"
                component={CsvDownload}
              />
              <PrivateRoute
                exact
                path="/admin/app/edit-report"
                component={ReportContent}
              />
              <PrivateRoute
                exact
                path="/admin/app/edit-report/vpi/orientation-text"
                component={ReportDetails}
              />
              <PrivateRoute
                exact
                path="/admin/app/edit-report/vpi/inference"
                component={ReportDetails}
              />
              <PrivateRoute
                exact
                path="/admin/app/edit-report/vpi/implications"
                component={ReportDetails}
              />
              <PrivateRoute
                exact
                path="/admin/app/edit-report/vpi/action-items"
                component={ReportDetails}
              />
              <PrivateRoute
                exact
                path="/admin/app/edit-report/vvi/slot-text"
                component={ReportDetails}
              />
              <PrivateRoute
                exact
                path="/change-password"
                component={ChangePassword}
              />
              <PrivateRoute
                exact
                path="/change-admin-password"
                component={ChangeAdminPassword}
              />
              <Route exact path="/404-page-not-found" component={page404} />
              <Route
                exact
                path="/set-password/:id/:id/"
                component={SetPassword}
              />
              <Route
                exact
                path="/assessment-expired"
                component={AssessmentCompleted}
              />
              <Route exact path="/forgot-password" component={ForgotPassword} />
              <Redirect from="/admin" to="/admin/app/dashboard" />
              <Redirect from="/app" to="/app/dashBoard" />
              <Redirect from="/redirect" to="/redirect" />
              <Redirect from="/" to="/login" />
            </Switch>

            <Route exact path="/login" component={LoginPage} />
            <Route exact path="/redirect" component={RedirectingLoginPage} />
          </div>
        </Router>
        <ToastContainer />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { alert } = state;
  return {
    alert,
  };
}

const connectedApp = connect(mapStateToProps)(App);
export { connectedApp as App };



// WEBPACK FOOTER //
// ./src/App/App.jsx